"use client";

import * as MapLibreGL from "maplibre-gl";
import { useEffect, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
import { cn } from "#/lib/utils";
import { useMarkerContext } from "./map-marker";
import { jsx as _jsx } from "react/jsx-runtime";
function MarkerTooltip({
  children,
  className,
  ...popupOptions
}) {
  const {
    marker,
    map
  } = useMarkerContext();
  const container = useMemo(() => document.createElement("div"), []);
  const prevTooltipOptions = useRef(popupOptions);
  const tooltip = useMemo(() => {
    const tooltipInstance = new MapLibreGL.Popup({
      offset: 16,
      ...popupOptions,
      closeOnClick: true,
      closeButton: false
    }).setMaxWidth("none");
    return tooltipInstance;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!map) return;
    tooltip.setDOMContent(container);
    const handleMouseEnter = () => {
      tooltip.setLngLat(marker.getLngLat()).addTo(map);
    };
    const handleMouseLeave = () => tooltip.remove();
    marker.getElement()?.addEventListener("mouseenter", handleMouseEnter);
    marker.getElement()?.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      marker.getElement()?.removeEventListener("mouseenter", handleMouseEnter);
      marker.getElement()?.removeEventListener("mouseleave", handleMouseLeave);
      tooltip.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  // Deliberate render-phase sync of the imperative MapLibre popup; the ref
  // only remembers the previously applied options.
  /* eslint-disable react-hooks/refs */
  if (tooltip.isOpen()) {
    const prev = prevTooltipOptions.current;
    if (prev.offset !== popupOptions.offset) {
      tooltip.setOffset(popupOptions.offset ?? 16);
    }
    if (prev.maxWidth !== popupOptions.maxWidth && popupOptions.maxWidth) {
      tooltip.setMaxWidth(popupOptions.maxWidth ?? "none");
    }
    prevTooltipOptions.current = popupOptions;
  }
  /* eslint-enable react-hooks/refs */

  return /*#__PURE__*/createPortal(/*#__PURE__*/_jsx("div", {
    className: cn("bg-foreground text-background animate-in fade-in-0 zoom-in-95 rounded-md px-2 py-1 text-xs shadow-md", className),
    children: children
  }), container);
}
export { MarkerTooltip };